// 病历复印
export default [
  /**
   * 病历复印申请-选择用途和内容
   */
  {
    path: '/medical-record/copy-apply',
    name: '/copy-apply',
    component: () => import('Pages/medical-record/copy-apply')
  },
  /**
   * 提交审核资料
   * query
   * **** hosId
   */
  {
    path: '/medical-record/express-delivery',
    name: '/express-delivery',
    component: () => import('Pages/medical-record/express-delivery')
  },
  /**
   * 提交资料成功
   * query
   * **** commpatId 患者id
   */
  {
    path: '/medical-record/submit-successfully',
    name: '/submit-successfully',
    component: () => import('Pages/medical-record/submit-successfully')
  },
  /**
   *  我的申请列表
   *  query
   *  **** id 患者id
   */
  {
    path: '/medical-record/my-application',
    name: '/my-application',
    component: () => import('Pages/medical-record/my-application')
  },
  /**
   * 我的申请详情
   * query
   * **** commpatId 患者id
   * **** id 订单id
   */
  {
    path: '/medical-record/application-details',
    name: '/application-details',
    component: () => import('Pages/medical-record/application-details')
  },
  /**
   *订单详情
   * query
   * **** commpatId 患者id
   * **** id 订单id
   */
  {
    path: '/medical-record/order-details',
    name: '/order-details',
    component: () => import('Pages/medical-record/order-details')
  }
]



// WEBPACK FOOTER //
// ./src/router/medicalRecordCopy.js